import {Injectable, ViewContainerRef} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class superAdminService {
    private isSuperAdmin: boolean;
    private _closeMenu = new BehaviorSubject<string>("close");
    public closeMenu = this._closeMenu.asObservable();
    public setCloseMenu(value:"close"){
      this._closeMenu.next(value);
    }

    setData(data:boolean){
        this.isSuperAdmin = data;
    } 

    getData(){
        return this.isSuperAdmin;
    }

    hasData(){
        if(this.isSuperAdmin != undefined)
        {
            return true ; 
        }
        return false ; 
    }  

}



// WEBPACK FOOTER //
// ./src/app/shared/services/superAdminService.ts